<template>
  <el-row style="padding: 8px; border-bottom: solid 1px #E6E6E6 ;background: #ffffff;">
    <el-col :span="2" style="text-align: left;">{{ calculateLabel(price.type, price.itemType) }}</el-col>
    <el-col :span="2" style="text-align: left;">
      <el-button
        v-if="mode !== 'view' && canDelete(price.itemType)"
        type="text"
        @click="$emit('remove', index)"
        style="padding: 0px; height: 30px; font-size: 20px; color:#EA6A2A;"
        icon="el-icon-delete"
      />
      <span v-else style="opacity:0">-</span>
    </el-col>
    <el-col :span="13" style="text-align: left;" :style="{ color: isNegative(price) ? '#EA6A2A' : '#000000' }">
      <span>{{ price.reason || '-' }}</span>
      <el-tag
        v-if="price.itemType === 'addon' && price.billingType === 'per_night'"
        type="info"
        color="#E5E7EB"
        size="small"
        style="color: #121931; border-radius: 8px; margin-left: 8px; vertical-align: middle;"
      >
        每晚
      </el-tag>
    </el-col>
    <el-col :span="2" style="text-align: center;" :style="{ color: isNegative(price) ? '#EA6A2A' : '#000000' }">x{{ price.qty }}</el-col>
    <el-col :span="5" style="text-align: right;" :style="{ color: isNegative(price) ? '#EA6A2A' : '#000000' }">
      <span> {{ isNegative(price) ? '-' : '' }} </span>
      {{ formatNumber(price.amount) }}
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'CalculatedOrderItemRow',
  props: {
    price: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String,
      default: 'edit',
    },
    editorMode: {
      type: String,
      default: 'price',
    },
  },
  methods: {
    isNegative(item) {
      return item.itemType === 'price' && ['discount', 'minus', 'subtract'].includes(item.type)
    },
    formatNumber(num) {
      const value = Number(num) || 0
      return value.toLocaleString()
    },
    calculateLabel(type, itemType = 'price') {
      if (itemType === 'addon') return '加購'
      const map = {
        add: '加價',
        minus: '減價',
        discount: '折扣',
      }
      return map[type] || '未知'
    },
    canDelete(itemType) {
      if (this.mode === 'live') return ['price', 'addon'].includes(itemType)
      if (this.editorMode === 'addon') return itemType === 'addon'
      return itemType === 'price'
    },
  },
}
</script>
